import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';


import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Payment } from './payment.model';
import { PaymentPopupService } from './payment-popup.service';
import { PaymentService } from './payment.service';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { School, SchoolService } from '../school';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { Principal, CRUD_ACTIONS } from '../../shared/index';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'jhi-payment-dialog',
    templateUrl: './payment-dialog.component.html'
})
export class PaymentDialogComponent extends AbstractDialogComponent implements OnInit {

    payment: Payment;
    authorities: any[];
    isSaving: boolean;

    students: Student[];

    search = this.studentTypeaheadService.search;

    resultFormatter = this.studentTypeaheadService.resultFormatter;

    inputFormatter = (student: any) => this.studentTypeaheadService.inputFormatter(student, () => this.payment.payer['user']);

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        alertService: AlertService,
        private paymentService: PaymentService,
        private studentService: StudentService,
        schoolService: SchoolService,
        private eventManager: EventManager,
        private studentTypeaheadService: StudentTypeaheadService,
        private router: Router,
        principal: Principal
    ) {
        super(schoolService, alertService, principal);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.loadSchools();
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save(form: NgForm) {
        if (this.payment.payer instanceof Object) {
            this.isSaving = true;
            if (this.payment.id !== undefined) {
                this.paymentService.update(this.payment)
                    .subscribe((res: Payment) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE),
                        (res: HttpErrorResponse) => this.onSaveError(res));
            } else {
                this.paymentService.create(this.payment)
                    .subscribe((res: Payment) =>
                        this.onSaveSuccess(res, CRUD_ACTIONS.CREATE),
                        (res: HttpErrorResponse) => this.onSaveError(res));
            }
        } else {
            let payerInput = form !== undefined ? form.controls['payer'] : null;
            if (payerInput !== null) {
                payerInput.reset();
            }
        }

    }

    private onSaveSuccess(result: Payment, action: String) {
        this.eventManager.broadcast({ name: 'paymentListModification', content: {
            action: action,
            content: result
        }});

        if (action === CRUD_ACTIONS.CREATE) {
            this.router.navigateByUrl('/payment/' + result['id'], { replaceUrl: true });
        }

        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    trackStudentById(index: number, item: Student) {
        return item.id;
    }

    trackSchoolById(index: number, item: School) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-payment-popup',
    template: ''
})
export class PaymentPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private paymentPopupService: PaymentPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.paymentPopupService
                    .open(PaymentDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.paymentPopupService
                    .open(PaymentDialogComponent as Component);
            }

        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment/payment-dialog.component.ts